function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M16.0905 9.36159C16.3032 9.14891 16.3032 8.85116 16.0905 8.63849L11.8369 4.38493C11.6243 4.17225 11.284 4.17225 11.1138 4.38493L10.2631 5.23564C10.0504 5.40578 10.0504 5.74606 10.2631 5.95874L12.4324 7.95792L4.76043 7.95792C4.46268 7.95792 4.25 8.21313 4.25 8.46834L4.25 9.4892C4.25 9.78695 4.46268 9.99962 4.76043 9.99962L12.4324 9.99962L10.2631 12.0413C10.0504 12.254 10.0504 12.5943 10.2631 12.7644L11.1138 13.6151C11.284 13.8278 11.6243 13.8278 11.8369 13.6151L16.0905 9.36159Z",
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  d: "M0.25 16.5333C0.25 16.7911 0.458934 17 0.716667 17H1.82333C2.08107 17 2.29 16.7911 2.29 16.5333V1.46667C2.29 1.20893 2.08107 1 1.82333 1H0.716667C0.458934 1 0.25 1.20893 0.25 1.46667V16.5333Z",
  fill: "#004152"
});

var _ref4 = React.createElement("path", {
  d: "M0.25 16.5333C0.25 16.7911 0.458934 17 0.716667 17H5.78333C6.04107 17 6.25 16.7911 6.25 16.5333V15.4267C6.25 15.1689 6.04107 14.96 5.78333 14.96H0.716666C0.458934 14.96 0.25 15.1689 0.25 15.4267V16.5333Z",
  fill: "#004152"
});

var _ref5 = React.createElement("path", {
  d: "M0.25 2.53333C0.25 2.79107 0.458934 3 0.716667 3H5.78333C6.04107 3 6.25 2.79107 6.25 2.53333V1.42667C6.25 1.16893 6.04107 0.96 5.78333 0.96H0.716666C0.458934 0.96 0.25 1.16893 0.25 1.42667V2.53333Z",
  fill: "#004152"
});

var SvgSignOut = function SvgSignOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSignOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-out.52382cef.svg";
export { ForwardRef as ReactComponent };